import React from 'react';
import PropTypes from 'prop-types';
import CwToggleButton from '../cwtogglebutton/CwToggleButton';

const CwToggleButtonGroup = (props) => {

  const createToggleButton = (item) => {

    if (!props.value || props.value.id === undefined) {
      return;
    }
    
    const value = item.id === props.value.id;
    const toggleButton = <CwToggleButton cwId={`${props.cwId}_${item.id}`} item={item} text={item.name} key={item.id} onClick={(item) => props.onChange(item)} value={value}
      onFocus={props.onFocus} onBlur={props.onBlur} tabIndex={props.tabIndex}/>;
    return <td key={item.id}>{toggleButton}</td>;
  };

  const getToggleButtons = () => {
    if (!props.toggleButtons || !props.toggleButtons.length > 0) {
      return null;
    }
    let columns = props.columns ? props.columns : props.toggleButtons.length;
    let rows = [];
    let j = 0;
    let cells = [];
    for (let i = 0; i < props.toggleButtons.length; i++) {
      let item = props.toggleButtons[i];
      cells.push(createToggleButton(item));
      j++;
      if (j > columns - 1 || i === props.toggleButtons.length - 1) {
        j = 0;
        rows.push(<tr key={`item{${i}`}>{cells}</tr>);
        cells = [];
      }
    }
    return <table><tbody style={{ width: '100%' }}>{rows}</tbody></table>;
  };

  return (
    getToggleButtons()
  );
};

CwToggleButtonGroup.propTypes = {

  /**
 * Connectwise element id to be used as unique identifier
 */
  cwId: PropTypes.string,
  /**
   * Array of toggle buttons for the group with {id, name} as its shape
   */
  toggleButtons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Id of toggle button that should be checked, if it does not match
   * an id of a toggle button on  the props.toggleButtons, none will
   * be checked
   */
  value: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.string
  }),
  /**
   * Used to lay out the toggle buttons, it will display the toggle buttons
   * across this many columns
   */
  columns: PropTypes.number,
  /**
   * Callback function fired when a toggle button in this group is clicked
   */
  onChange: PropTypes.func,
  /**
   * Callback function fired when a toggle button is focued
   */
  onFocus: PropTypes.func,
  /**
   * Callback function fired when a toggle button is blured
   */
  onBlur: PropTypes.func,
  /**
   * used to control tab order
   */
  tabIndex: PropTypes.number,
  /**
   * Unused, added to satisfy pod element check
   */
  invalid: PropTypes.bool,
};

CwToggleButtonGroup.defaultProps = {
  tabIndex: 0,
};

export default CwToggleButtonGroup;


// WEBPACK FOOTER //
// ./src/components/cwtogglebuttongroup/CwToggleButtonGroup.jsx